export default function get(key, def = null, prefix = '') {
  let retval = def;
  try {
    retval = JSON.parse(localStorage[`${prefix}${key}`]);
  } catch (ex) {
    // ok
  }
  return retval;
}
